export default "__VITE_ASSET__BpSfF5Vk__"